import http from '../utils/http'
import joinParams from "../utils/join-params";

export default {
	get(data) {
		const url = joinParams('/calendar/tournaments', data);
		return http.get(url);
	},
}